import { render, staticRenderFns } from "./menuDetail.vue?vue&type=template&id=6deaeb46&"
import script from "./menuDetail.vue?vue&type=script&lang=js&"
export * from "./menuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6deaeb46')) {
      api.createRecord('6deaeb46', component.options)
    } else {
      api.reload('6deaeb46', component.options)
    }
    module.hot.accept("./menuDetail.vue?vue&type=template&id=6deaeb46&", function () {
      api.rerender('6deaeb46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/menuDetail.vue"
export default component.exports